export default __webpack_public_path__ + "static/media/controls_mouse_3.1e17d125.svg";